import { render, staticRenderFns } from "./ExampleRepository.vue?vue&type=template&id=797e5718&scoped=true&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ExampleRepository.vue?vue&type=script&lang=js&"
export * from "./ExampleRepository.vue?vue&type=script&lang=js&"
import style0 from "./ExampleRepository.vue?vue&type=style&index=0&id=797e5718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797e5718",
  null
  
)

export default component.exports